var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.49 21.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ea2253;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.84.18l7.65,21.1h-4.86L103,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.24.18l7.65,21.1H96L88.38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.64.18l7.65,21.1H81.43L73.78.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,.18l7.65,21.1H66.83L59.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.44.18l7.65,21.1H52.23L44.58.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.84.18l7.65,21.1H37.63L30,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.45,0l7.66,21.1H22.25L14.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.85,0,12.5,21.1H7.65L0,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.5708e2bbaee40e14d796c8db6b180f5a.svg";
export { ForwardRef as ReactComponent };